import * as React from "react";
import {
  InvalidateOptions,
  InvalidateQueryFilters,
  QueryClient,
  useQueryClient,
} from "react-query";
import { CustomQueryKey } from "./QueryKeys";
import { querykeyToArray } from "./useCustomQuery";

type CustomQueryClient = {
  queryClient: QueryClient;
  invalidateCustomQueries: (
    queryKey?: CustomQueryKey,
    filters?: InvalidateQueryFilters,
    options?: InvalidateOptions,
  ) => Promise<void>;
};
export function useCustomQueryClient(): CustomQueryClient {
  const queryClient = useQueryClient();
  const invalidateCustomQueries = React.useCallback(
    (
      queryKey?: CustomQueryKey,
      filters?: InvalidateQueryFilters,
      options?: InvalidateOptions,
    ) => {
      const fixedKeys = queryKey ? querykeyToArray(queryKey) : undefined;
      return queryClient.invalidateQueries(fixedKeys, filters, options);
    },
    [queryClient],
  );
  return { queryClient, invalidateCustomQueries };
}
